import React,{Component} from "react";
import ASUTab from './ASUTabSystem.js';
import { connect } from 'react-redux';
import InactiveWindow from '../../Logout/InActive';
import Idle from 'react-idle';
import { Modal } from 'reactstrap';
import classnames from 'classnames';

class ASU extends Component {

    componentWillMount(){
        sessionStorage.setItem('activeContent',1);  
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
            this.setState({ LogOffTime : Number(E_LogoffTime) });
        }
    }

      constructor(props) {
        super(props);
        this.state = {              
           inactive_modal: false,
           LogOffTime: 1200000
        }  
        this.Inactivetoggle = this.Inactivetoggle.bind(this);
     }

        Inactivetoggle() {
            this.setState({
                inactive_modal: !this.state.inactive_modal
            });
        }
    
        Extend_Session = (someArg) => {
            this.Inactivetoggle();
        }


     render(){
           
       return(

            <div className="Ensemble">
                <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
                    if (idle) {
                        this.setState({ inactive_modal: true });
                    }
                }} />
                {                
                  <div className="Ensemble_Content_FullPage"><ASUTab /></div>
                }
                <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={classnames({ classnames: this.props.className }, "ModalContainer InActive_Short_Modal")} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                </Modal>

            </div>
        );
    }
};

const mapStateToProps = state => {
      return {
            
      };
};
export default connect(mapStateToProps, null)(ASU);